module.exports = __webpack_public_path__ + "static/img/guide-16.915ff7f8.png";